import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CognitoService } from '../auth/cognito.service';
import { error } from 'jquery';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    private authenticatorService: AuthenticatorService
  ) {}

  async ngOnInit() {
    this.cognitoService.currentUser();
    await this.cognitoService
      .getUser()
      .then((result) => {
        console.log(result);
        console.log('Get User');
      })
      .catch((error) => {
        console.log(error);
        console.log('Get User Failed');
      });

    if (this.authenticatorService.authStatus === 'authenticated') {
      this.router
        .navigate(['/home'])
        .then(() => console.log('navigate to home'));
    } else {
      await this.cognitoService
        .federatedSignIn()
        .then(() => console.log('federate sign in'))
        .catch((error) => {
          console.log(error);
          console.log('federate sign in Failed');
        });
    }
  }
}
